(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ShowIntegrationController', ShowIntegrationController);

    ShowIntegrationController.$inject = ['entity', '$uibModalInstance'];

    function ShowIntegrationController (entity, $uibModalInstance) {
        var vm = this;

        vm.client = entity;

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
